export const controlHeroBuy = {
  title: 'Köp vilken bil du vill. Av vem du vill.',
  text: 'Vi hjälper dig med riktigt billån och möjlighet till restvärde eller en direktöverföring till säljaren. Oavsett var du hittat bilen.',
  controlTitle: 'Vilken bil vill du titta på?',
  controlButtonText: 'Se historik',
  mobileSrc: '/assets/images/control-hero-mobile.jpg',
  desktopSrc: '/assets/images/control-hero.jpg',
};

export const controlHeroSell = {
  title: 'Sälja begagnad bil ',
  text: 'Erbjud finansiering, garanti och försäkring när du säljer din bil. Sälj bilen med Blipp och gör en bättre affär.',
  controlTitle: 'Kolla värdet kostnadsfritt',
  controlButtonText: 'Boka tid med Blipp',
  mobileSrc: '/assets/images/sell-hero-mobile.jpg',
  desktopSrc: '/assets/images/sell-hero-desktop.jpg',
};

export const controlHeroBlocket = {
  title: 'Köpa begagnad bil på Blocket',
  text: 'Köp bil på Blocket eller annan marknadsplats med hjälp av Blipp för en trygg och smidig affär. Möjlighet till billån, garanti och hjälp med transaktionen. Kontrollera fordonet innan köp och boka sedan en tid med Blipp för affär.',
  controlTitle: 'Vilken bil vill du köpa?',
  controlButtonText: 'Kontrollera och boka tid',
  mobileSrc: '/assets/images/blocket-hero-mobile.jpg',
  desktopSrc: '/assets/images/blocket-hero-desktop.jpg',
};

export const controlHeroBookTime = {
  title: 'Boka tid med Blipp',
  text: 'När du hittat en bil du vill köpa och är överens med säljaren om tid och plats, bokar du en tid med Blipp och säljaren här.',
  controlTitle: 'Vilken bil vill du köpa?',
  controlButtonText: 'Boka tid med Blipp',
  mobileSrc: '/assets/images/blocket-hero-mobile.jpg',
  desktopSrc: '/assets/images/blocket-hero-desktop.jpg',
};
